import { combineReducers } from 'redux';

import conditionReducer from './condition';
import detailsReducer from './details';
import listReducer from './list';
import globalReducer from './global';

// combine Redux reducers into one reducer to access Redux states accross the project
const rootReducer = combineReducers({
    condition: conditionReducer,
    details: detailsReducer,
    list: listReducer,
    global: globalReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js